import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class DummyGroupBoxViewModel extends ControlViewModel {

    /**
     * Der Kontext des ViewModels
     */
    public context: any;

    /**
     * Definiert den Namen des inneren Layouts
     */
    public layout: string;

    /**
     * Enthält die inneren DetailViewGroups
     */
    public detailViewGroups: Array<any>;

    /**
     * Enthält die inneren DetailViewItems
     */
    public detailViewItems: Array<any>;

    /**
     * Der Titel
     */
    public label: LabelViewModel;

    /**
     * Das ViewModel für die DummyGroupBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.context = this.paramOrDefault(params.context, null);
        this.layout = this.paramOrDefault(params.layout, 'NoneLayout');
        this.detailViewGroups = this.paramOrDefault(params.detailViewGroups, []);
        this.detailViewItems = this.paramOrDefault(params.detailViewItems, []);
        this.label = this.paramOrDefault(params.label);
    }
}

ComponentManager.setViewModel('DummyGroupBoxViewModel', DummyGroupBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');